import React from 'react';

import {Container, StoresColumn} from './styles';
import {StoreShimmer} from '../StoreShimmer';

interface Props {
  showDivider?: boolean;
}

export function HorizontalStoreShimmer({showDivider = true}: Props) {
  return (
    <Container>
      <StoresColumn>
        <StoreShimmer first border={showDivider} />
        <StoreShimmer border={showDivider} />
        <StoreShimmer border={showDivider} />
      </StoresColumn>
      <StoresColumn>
        <StoreShimmer first border={showDivider} />
        <StoreShimmer border={showDivider} />
        <StoreShimmer border={showDivider} />
      </StoresColumn>
    </Container>
  );
}
